import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from '../../../admin.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/utils/loader.service';
interface DialogData {
  bDisabled: boolean
}

@Component({
  selector: 'app-quality-check',
  templateUrl: './quality-check.component.html',
  styleUrls: ['./quality-check.component.scss']
})
export class QualityCheckComponent implements OnInit {

  proofUploaded: boolean;
  uploaded_file_name="";
  order_id: any;
  invoice_id: any;
  invoice_details: any;
  shipmentNo: any;
  qualityFilevalue: any;
  is_Qualitychecked : boolean = false;
  vendorOrderItemdata: any;
  payment_file: any;
  uploadFilepaths: any;

  constructor(   public dialogref: MatDialogRef<QualityCheckComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private toastr: ToastrService,
    private loaderService: LoaderService) { }

  private paymentfilesControl = new FormControl(null, FileUploadValidators.filesLimit(1));
  public demoForm = new FormGroup({
    files: this.paymentfilesControl
  });
  
  ngOnInit(): void {
    console.log('skva', this.data['data'])
    this.vendorOrderItemdata = this.data["data"];
    this.order_id = this.data["order_id"];
    this.invoice_id = this.data["invoice_id"];
    if(this.vendorOrderItemdata?.is_qualitycheck) {
    this.is_Qualitychecked = Boolean(JSON.parse(this.vendorOrderItemdata?.is_qualitycheck));
    }
    if(this.is_Qualitychecked) {
      let fileval = this.vendorOrderItemdata?.qualitycheck_file.split('/');
      this.uploaded_file_name = fileval[fileval.length -1];
   
      // this.uploadFilepaths = this.vendorOrderItemdata?.painting_file ;
      // this.uploaded_file_name = fileval;
      this.proofUploaded = true ;
    }
    this.qualitycheckFile();
  }

  submit()
  {
    this.loaderService.display(true);
    let formData = new FormData();

     formData.append('vendor_order_items[qualitycheck]', this.demoForm.value.files[0]);
     formData.append('vendor_order_items[is_qualitycheck]',this.is_Qualitychecked.toString());

    console.log('!',this.order_id,'!!',this.vendorOrderItemdata?.vendor_item_id, '!!!',formData)
    this.adminService.addQualityCheck(this.order_id,this.vendorOrderItemdata?.vendor_item_id, formData).subscribe(
      res => {
        this.toastr.success('Quality Check file has been Submitted', 'Success');
        this.loaderService.display(false);
        this.close();
      },
      err => {
        this.toastr.error('Something went Wrong', 'Error');
        this.loaderService.display(false);
        this.close();
      }

    );
  }

  qualitycheckFile() {
    const file = this.demoForm.get('files')
    file.valueChanges.subscribe(
      res => {
        this.payment_file = res[0]
        console.log(this.payment_file)
        
      }
    )
  }

  close() {
    this.dialogref.close();
  }

  onchangeQualitycheckValue(evt)
  {
    
  }

  removeFile()
  {
    this.uploaded_file_name = '';
  }
  downloadUrl(){
    
  //  let path = 'admin/partner-orders/painting/' + this.vendorOrderItemdata?.vendor_item_id + '/' + this.uploaded_file_name;
    this.adminService.downloadQualityCheckFile(this.vendorOrderItemdata?.vendor_item_id,this.uploaded_file_name).subscribe(
      (res: any) => {
        window.open(res.vendor_painting_url, "_blank");
        this.close();
      },
      err => {
        this.toastr.error('Something went Wrong', 'Error');
        this.close();
      }

    );
    
  }

}
